export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const footerLinks = [
    { label: '热门榜单', href: '#ranking' },
    { label: '专题合集', href: '#index' },
    { label: '关于我们', href: '#about' },
    { label: '最新动态', href: '#updates' },
    { label: '常见问答', href: '#faq' },
    { label: '联系我们', href: '#contact' },
  ];

  return (
    <footer id="footer" className="bg-background-50 border-t border-background-200/50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => handleClick(e, '#hero')}
              className="inline-block text-xl font-heading font-bold text-primary-500 mb-3 cursor-pointer"
            >
              琪琪影院
            </a>
            <p className="text-xs text-foreground-500 leading-relaxed">
              琪琪影院提供高清影视蓝光画质在线观看，不缓冲播放技术带来流畅观影体验，超清视频免费看，海量影视资源即时点播。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">快速导航</h4>
            <div className="space-y-2">
              {footerLinks.slice(0, 3).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleClick(e, link.href)}
                  className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">更多内容</h4>
            <div className="space-y-2">
              {footerLinks.slice(3).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleClick(e, link.href)}
                  className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500">敬请期待</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 琪琪影院. 本站为内容聚合展示平台.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}